import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';

import { IS_CDN_ENABLED, LOCIZE_PROJECT_ID } from '../utils/i18n/config';

/** GSSP 는 서버가 최신 값을 내려주므로 SSG 만 다시 읽는다. */
export const useI18nCdnOverride = () => {
  const { i18n } = useTranslation();

  useEffect(
    function reloadTranslationsFromCdn() {
      const language = i18n.language;

      // __NEXT_DATA__.gssp 는 비공식 API 다. 사라지면 undefined 가 되어 훅이 그대로 돈다.
      const isRenderedByGssp = Boolean(
        (window as unknown as { __NEXT_DATA__?: { gssp?: boolean } }).__NEXT_DATA__?.gssp,
      );

      if (isRenderedByGssp || !IS_CDN_ENABLED || !LOCIZE_PROJECT_ID || !language) {
        return;
      }

      // 인자를 생략하면 fallback 언어까지 전부 읽는다. 현재 언어·네임스페이스만 지정한다.
      void i18n
        .reloadResources([language], [i18n.options.ns ?? []].flat())
        .catch((error: unknown) => {
          console.warn(
            `i18n CDN 번역 조회 실패 - 서버가 내려준 값을 유지한다: ${
              error instanceof Error ? error.message : String(error)
            }`,
          );
        });
    },
    [i18n, i18n.language],
  );
};
